import { useTheme } from "next-themes"
import type { CSSProperties } from "react"
import { Toaster as Sonner, ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          // Por encima de Dialog/AlertDialog (z-50) para no ocultar errores de validación.
          zIndex: 100,
        } as CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
